import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const StyledHeader = styled(Box)({
  width: "100%",
  height: "auto",
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  zIndex: 0,
});

export const StyledWatermark = styled(Box)({
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 0,
  margin: "auto",
  opacity: 0.10,
});
